(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-utils/protected-route/assets/javascripts/protected-route.js') >= 0) return;  svs.modules.push('/components/lb-utils/protected-route/assets/javascripts/protected-route.js');
"use strict";

const useAuth = svs.components.lbUtils.protectedRoute.useAuth;
const userSession = svs.core.userSession;
const _userSession$roles = userSession.roles,
  INTERNAL = _userSession$roles.INTERNAL,
  RETAILER = _userSession$roles.RETAILER;
const customer_login = svs.components.customer_login;
const helpers = svs.components.lbUtils.protectedRoute.helpers;
const ProtectedRoute = _ref => {
  let roles = _ref.roles,
    children = _ref.children;
  const allowedSession = useAuth(roles);
  if (!allowedSession && (userSession.hasRole(RETAILER) || userSession.hasRole(INTERNAL))) {
    helpers.reloadWindow();
    return null;
  } else if (!allowedSession) {
    customer_login.login();
    return null;
  }
  return children;
};
ProtectedRoute.propTypes = {
  children: PropTypes.node,
  roles: PropTypes.arrayOf(PropTypes.string)
};
setGlobal('svs.components.lbUtils.protectedRoute.ProtectedRoute', ProtectedRoute);

 })(window);